import { atom } from 'recoil';

export const PreviewDataState = atom({
    key: 'PreviewDataState', 
    default: {
        show: false,
        data:null
    }, 
});